
















import VueOptions from '@utils/VueOptions'
import TitlePatternUtility from '@utils/TitlePatternUtility'

settings =
  name: 'Back'
  vue:
    props: ['nav', 'ctx', 'v1']
    computed:
      crumbs: -> @ctxToBreadcrumbs()

    methods:
      ownerToBreadscrumb: (owner) ->
        crumb = {
          value: owner.email
        }

        if owner.type == "Organizer"
          crumb.slug = "/organizers/#{owner.id}"
        else
          crumb.slug = "/brand-reps/#{owner.id}"

        crumb

      sponsorToBreadscrumb: (sponsor) ->
        {
          value: sponsor.name
          slug: "/sponsors/#{sponsor.id}"
        }

      supplierToBreadscrumb: (supplier) ->
        {
          value: supplier.name
          slug: "/suppliers/#{supplier.id}"
        }

      audienceListingToBreadscrumb: (listing) ->
        {
          value: TitlePatternUtility.formatListingTitle(listing)
          # slug: "/events/#{event.id}/overview"
        }

      vendorListingToBreadcrumb: (listing) ->
        value: TitlePatternUtility.formatListingTitle(listing)

      v1ToBreadcrumbs: ->
        return null unless @v1?.id?
        {
          value: "V1"
          url: "https://app-v1.recess.is/#{@v1.model.toLowerCase()}s/#{@v1.id}"
        }

      ctxToBreadcrumbs: ->
        crumbs = []

        if @ctx?.owner
          crumbs.push(@ownerToBreadscrumb(@ctx.owner))

        if @ctx?.sponsor?.org
          crumbs.push(@sponsorToBreadscrumb(@ctx.sponsor.org))

        if @ctx?.sponsor?.sub_org
          crumbs.push(@sponsorToBreadscrumb(@ctx.sponsor.sub_org))

        if @ctx?.sponsor?.sub_orgs
          crumbs = crumbs.concat(@ctx.sponsor.sub_orgs.map(@sponsorToBreadscrumb))

        if @ctx?.supplier?.org
          crumbs.push(@supplierToBreadscrumb(@ctx.supplier.org))

        if @ctx?.supplier?.sub_org
          crumbs.push(@supplierToBreadscrumb(@ctx.supplier.sub_org))

        if @ctx?.supplier?.sub_orgs
          crumbs = crumbs.concat(@ctx.supplier.sub_orgs.map(@supplierToBreadscrumb))

        if @ctx?.audience_listing?.owner
          crumbs.push(@ownerToBreadscrumb(@ctx.audience_listing.owner))

        if @ctx?.audience_listing?.id
          crumbs.push(@audienceListingToBreadscrumb(@ctx.audience_listing))

        if @ctx?.vendor_listing?.owner
          crumbs.push(@ownerToBreadscrumb(@ctx.vendor_listing.owner))

        if @ctx?.vendor_listing?.id
          crumbs.push(@vendorListingToBreadcrumb(@ctx.vendor_listing))

        crumbs.push(@v1ToBreadcrumbs()) if @v1?.id?
        crumbs

      goBack: ->
        if @nav? then @['nav']?() else @$router.go(-1)

export default VueOptions.vue settings
